/**
 * Portal Manta · agAluciGuardSICRO
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { aluciAuditarTexto } from './aluciAuditarTexto.jsx';

function agAluciGuardSICRO(ctx, prev){
  if (!ctx || !ctx.texto) return {status:'sem-texto'};
  const env = aluciAuditarTexto(ctx.texto, ctx.opcoes);
  const achados = env.achados.filter(a => a.tipo === 'AL-03_sicro');
  return {sub:'Auditor SICRO', status:achados.length===0?'ok':'atencao', msg:achados.length+' aluci AL-03 (SICRO)', achados};
}

export { agAluciGuardSICRO };
export default agAluciGuardSICRO;
